import { configureStore } from '@reduxjs/toolkit'

// **Reducer Imports
import authReducer from './slice/auth'
import candidateReducer from './slice/candidate'
import challengeReducer from './slice/challenge'
import contestReducer from './slice/contest'
import coursesReducer from './slice/courses'
import databaseReducer from './slice/database'
import developerReducer from './slice/developer'
import editorReducer from './slice/editor'
import homeReducer from './slice/home'
import learnerReducer from './slice/learner'
import usersReducer from './slice/users'
import workspaceReducer from './slice/workspace'
import jobDescriptionReducer from './slice/job-descriptions'
import AiTokenHistoryReducer from './slice/ai-token-history'

// **ENV Variable

import { ENVIRONMENT } from '../env/env'

const rootReducer = {
  auth: authReducer,
  workspace: workspaceReducer,
  challenge: challengeReducer,
  contest: contestReducer,
  editor: editorReducer,
  candidate: candidateReducer,
  users: usersReducer,
  database: databaseReducer,
  developer: developerReducer,
  courses: coursesReducer,
  learner: learnerReducer,
  home: homeReducer,
  jobDescription: jobDescriptionReducer,
  aiTokenHistory: AiTokenHistoryReducer
}

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: false
    })
  },
  devTools: ENVIRONMENT?.toLowerCase() === 'dev'
})

export { store }
